import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { SECONDS_IN_DAY } from 'modules/api/const';
import { convertBlocksToSeconds } from 'modules/api/utils';
import { ONE } from 'modules/common/const';

import { getDelegateStakingPoolContract } from '../contracts/getDelegateStakingPoolContract';

export async function getUnstakePeriodDays(
  client: PublicClient,
  poolAddress: Address,
): Promise<BigNumber> {
  const contract = getDelegateStakingPoolContract(client, poolAddress);

  const blocksRaw = await contract.read.UNBONDING_PERIOD();

  const days = new BigNumber(convertBlocksToSeconds(Number(blocksRaw))).div(
    SECONDS_IN_DAY,
  );

  return days.isGreaterThan(ONE) ? days.integerValue() : days.decimalPlaces(7);
}
